module.exports = __webpack_public_path__ + "5f7d822cd26e81f00863015eda83d87b.fbx";